import { Button } from "@studyplus/boron-ui";
import * as React from "react";
import { useFlashMessage } from "../../../../../../../hooks/useFlashMessage";
import StudentInterface from "../../../../../../../interfaces/StudentInterface";
import type {
  StudyRecordCommentInterface,
  StudyRecordWithRestrictedAttributes,
} from "../../../../../../../interfaces/StudyRecordInterface";
import styles from "./styles.scss";
import { TextArea } from "./TextArea";
import { usePostTimelineComment } from "./usePostTimelineComment";

interface Props {
  studyRecord: StudyRecordWithRestrictedAttributes;
  student: StudentInterface;
  canSendComment: boolean;
  comment: string;
  onAddComment: (comment: StudyRecordCommentInterface) => void;
  setComment: React.Dispatch<React.SetStateAction<string>>;
}

export const TimelineCommentForm = ({
  student,
  studyRecord,
  canSendComment,
  comment,
  onAddComment,
  setComment,
}: Props) => {
  const { showErrorMessage } = useFlashMessage();
  const { mutate, isPending } = usePostTimelineComment({
    studentId: student.id,
    studyRecordHashid: studyRecord.id,
    onSuccess: (postedComment) => {
      onAddComment(postedComment);
      setComment("");
    },
    onError: () => {
      showErrorMessage("コメントが送信できませんでした");
    },
  });

  const isDisabled = comment.trim() === "" || !canSendComment || isPending;
  const isRestricted = studyRecord.restrictedAttributes.includes("comments");

  const handleClickButton = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault();

    if (isDisabled) {
      return;
    }

    mutate(comment);
  };

  return (
    <form className={styles.root}>
      <TextArea
        comment={comment}
        onChangeComment={setComment}
        isRestricted={isRestricted}
        canSendComment={canSendComment}
      />
      <Button
        type="submit"
        disabled={isDisabled}
        className={styles.button}
        onClick={(e) => handleClickButton(e)}
      >
        送信
      </Button>
    </form>
  );
};
